// module.exports = require('@nawasrah/khareta-graphql-queries');
module.exports = require('./queries/index');
